// assets
import { IconFileSearch, IconHistory } from '@tabler/icons';

// constant
const icons = {
  IconFileSearch,
  IconHistory
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const logs = {
  id: 'logs',
  title: 'ログさらい',
  type: 'group',
  children: [
    {
      id: 'log-history',
      title: 'リクエスト一覧',
      type: 'item',
      url: '/logs/history',
      icon: icons.IconHistory,
      breadcrumbs: false
    }
  ]
};

export default logs;
